import { render } from "./ImagegalleryComponent.vue?vue&type=template&id=2b325d3c"
import script from "./ImagegalleryComponent.vue?vue&type=script&lang=js"
export * from "./ImagegalleryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__